import React from 'react';
import { bool, func, shape, string } from 'prop-types';
import { Link } from 'react-router-dom';

import ApplicationHeader from '../../../../ApplicationHeader/ApplicationHeader';
import PermissionGate from '../../../../../../../components/PermissionGate/';

const SimulatorHeader = ({
  heading,
  subpageHeading,
  description,
  cta,
  applicationId,
  setSelectedVehicle,
  setIsFetching,
}) => {
  const handleHomeClick = () => {
    if (setIsFetching) {
      setIsFetching(true);
    }
    setSelectedVehicle({});
  };

  return (
    <ApplicationHeader
      heading={heading}
      backLink={{
        path: subpageHeading ? `/apps/${applicationId}/simulator` : null,
        onClick: subpageHeading ? handleHomeClick : null,
      }}
      subpageHeading={subpageHeading}
      description={description}
      rightSideContent={cta && cta.text && cta.onclick && (
        <PermissionGate dashboardPermission="write_simulator">
          <Link
            to={cta.path}
            id={`${heading}-header-cta`}
            onClick={cta.onclick}
            variant="outlined"
            display="flex"
            className="button-link"
          >
            {cta.text}
          </Link>
        </PermissionGate>
      )}
    />
  );
};

export default SimulatorHeader;

SimulatorHeader.propTypes = {
  heading: string.isRequired,
  subpageHeading: string,
  description: string,
  applicationId: string,
  setSelectedVehicle: func,
  setIsFetching: func,
  cta: shape({
    text: string.isRequired,
    path: string.isRequired,
    onclick: func.isRequired,
    variant: string,
    plusIcon: bool,
  }),
};

SimulatorHeader.defaultProps = {
  subpageHeading: null,
  description: null,
  applicationId: null,
  setSelectedVehicle: null,
  setIsFetching: null,
  cta: null,
};
